/**
 * Foremark 刻印预览/编辑器 — Home + Product 共用
 * 通过 data-mode="preview|editor" 区分简化/完整模式
 */
(function () {
  'use strict';

  function initForemarkEngrave() {
    var root = document.querySelector('[data-engrave-root]');
    if (!root) return;

    var theme = window.ForemarkTheme || {};
    var translations = theme.translations || {};
    var assets = theme.assets || {};

    var COLOR_MAP = {
      black:  { hex: '#1a1a1a', engrave: 'rgba(255,255,255,0.95)', image: assets.product5 || assets.heroProduct || '' },
      gold:   { hex: '#c9a227', engrave: 'rgba(192, 192, 192, 0.95)', image: assets.product2 || '' },
      green:  { hex: '#2d5a3d', engrave: 'rgba(230,245,230,0.95)', image: assets.product1 || '' },
      red:    { hex: '#8b1a1a', engrave: 'rgba(255,225,215,0.95)', image: assets.product3 || '' },
      blue:   { hex: '#1e4d6b', engrave: 'rgba(210,235,255,0.95)', image: assets.product4 || assets.heroProduct || '' }
    };

    function normalizeColorKey(key) {
      if (!key) return 'black';
      var k = String(key).toLowerCase().trim();
      if (COLOR_MAP[k]) return k;

      var aliases = {
        'ブラック': 'black',
        'ゴールド': 'gold',
        'フォレストグリーン': 'green',
        'クリムゾンレッド': 'red',
        'オーシャンブルー': 'blue',
        'forest-green': 'green',
        'forest green': 'green',
        'crimson-red': 'red',
        'crimson red': 'red',
        'ocean-blue': 'blue',
        'ocean blue': 'blue'
      };
      if (aliases[k]) return aliases[k];
      if (k.indexOf('gold') !== -1 || k.indexOf('ゴールド') !== -1) return 'gold';
      if (k.indexOf('green') !== -1 || k.indexOf('グリーン') !== -1) return 'green';
      if (k.indexOf('red') !== -1 || k.indexOf('レッド') !== -1) return 'red';
      if (k.indexOf('blue') !== -1 || k.indexOf('ブルー') !== -1) return 'blue';
      return 'black';
    }

    function syncVariantFromColorKey(key) {
      var swatch = document.querySelector('.swatch[data-key="' + key + '"]');
      if (swatch && swatch.dataset.variantId && window.ForemarkThemeHandlers) {
        window.ForemarkThemeHandlers.onVariantSelect(
          swatch.dataset.variantId,
          swatch.dataset.name,
          swatch.dataset.price,
          swatch.dataset.available
        );
      }
    }

    var TEMPLATE_SAMPLES = translations.templateSamples || {
      classic:  { club: 'ACCORDIA GOLF', name: '山田 太郎', number: 'No. 1288' },
      minimal:  { club: 'ACCORDIA GOLF', name: 'YAMADA TARO', number: '' },
      monogram: { club: 'ACCORDIA GOLF', name: '山田 太郎', number: 'No. 1288' },
      club:     { club: 'TOKYO GOLF CLUB', name: '', number: 'Member 1288' },
      elegant:  { club: 'FOREMARK GOLF', name: 'Hanako S.', number: 'No. 007' },
      modern:   { club: 'GOLF CLUB', name: 'Suzuki Ken', number: '#2048' }
    };

    var FONT_MAP = {
      classic:     { family: '"Cormorant Garamond", "Noto Sans JP", serif', label: 'classic' },
      modern:      { family: '"DM Sans", "Noto Sans JP", sans-serif', label: 'modern' },
      japanese:    { family: '"Noto Sans JP", sans-serif', label: 'japanese' },
      traditional: { family: '"Playfair Display", "Noto Sans JP", serif', label: 'traditional' },
      serif:       { family: '"Libre Baskerville", "Noto Sans JP", serif', label: 'serif' },
      elegant:     { family: '"EB Garamond", "Noto Sans JP", serif', label: 'elegant' }
    };

    var SIZE_MAP = {
      sm: { cqmin: 10, labelKey: 'sm' },
      md: { cqmin: 12, labelKey: 'md' },
      lg: { cqmin: 14, labelKey: 'lg' },
      xl: { cqmin: 16, labelKey: 'xl' }
    };

    var mode = root.getAttribute('data-mode') || 'preview';
    var currentColor = 'black';
    var currentTemplate = 'classic';
    var currentFont = 'classic';
    var currentSize = 'md';
    var engraveColorMode = 'auto';
    var customEngraveColor = '#FFFFFF';
    var isDoubleSided = false;

    var tagCard = document.getElementById('tag-card');
    var tagEngrave = document.getElementById('tag-engrave');
    if (!tagCard || !tagEngrave) return;

    var tagCardBack = document.getElementById('tag-card-back');
    var tagEngraveBack = document.getElementById('tag-engrave-back');
    var previewDual = document.getElementById('tag-preview-dual');
    var previewBackFace = document.getElementById('tag-preview-back');
    var backSection = document.getElementById('engrave-back-section');
    var previewNote = document.getElementById('engrave-preview-note') || document.querySelector('.preview-note');

    function getEffectiveEngraveColor() {
      if (engraveColorMode === 'auto') {
        return COLOR_MAP[currentColor] ? COLOR_MAP[currentColor].engrave : 'rgba(255,255,255,0.95)';
      }
      if (engraveColorMode === 'custom') return customEngraveColor;
      return engraveColorMode;
    }

    function applyStyleToEngrave(el) {
      if (!el) return;
      var fontCfg = FONT_MAP[currentFont] || FONT_MAP.classic;
      var sizeCfg = SIZE_MAP[currentSize] || SIZE_MAP.md;
      var color = getEffectiveEngraveColor();

      el.style.fontFamily = fontCfg.family;
      el.style.fontSize = sizeCfg.cqmin + 'cqmin';
      el.style.setProperty('--engrave-color', color);
      el.style.color = color;
    }

    function applyEngraveStyle() {
      applyStyleToEngrave(tagEngrave);
      applyStyleToEngrave(tagEngraveBack);

      var sizeLabel = document.getElementById('size-label');
      if (sizeLabel && translations.sizes) {
        var sizeCfg = SIZE_MAP[currentSize] || SIZE_MAP.md;
        sizeLabel.textContent = translations.sizes[sizeCfg.labelKey] || sizeCfg.labelKey;
      }
      syncZoomPreview();
    }

    function applyTagSurface(cardEl, hex, colorKey) {
      if (!cardEl) return;
      cardEl.style.setProperty('--tag-color', hex);
      cardEl.style.background = hex;
      if (colorKey) cardEl.dataset.tagColor = colorKey;
    }

    function getMonogram(name) {
      if (!name) return '—';
      var parts = name.trim().split(/[\s　]+/);
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      }
      return name.slice(0, 2).toUpperCase();
    }

    function getEmblem(club) {
      if (!club) return 'FM';
      var words = club.trim().split(/[\s　]+/);
      if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
      return club.slice(0, 2).toUpperCase();
    }

    function setBackSectionVisible(enabled) {
      if (!backSection) return;
      backSection.hidden = !enabled;
      backSection.classList.toggle('is-open', enabled);
    }

    function setDoubleSided(enabled) {
      isDoubleSided = enabled;
      if (previewDual) previewDual.dataset.doubleSided = enabled ? 'true' : 'false';
      if (previewBackFace) previewBackFace.hidden = !enabled;
      setBackSectionVisible(enabled);
      if (previewNote) previewNote.hidden = !enabled;

      document.querySelectorAll('.js-double-sided-checkbox').forEach(function (cb) {
        if (cb.checked !== enabled) cb.checked = enabled;
      });

      if (enabled) {
        applyEngraveStyle();
        updatePreviewText();
      } else {
        syncZoomPreview();
      }
    }

    function applyColor(key) {
      key = normalizeColorKey(key);
      var cfg = COLOR_MAP[key];
      if (!cfg) return;
      currentColor = key;

      applyTagSurface(tagCard, cfg.hex, key);
      applyTagSurface(tagCardBack, cfg.hex, key);
      applyEngraveStyle();
      syncZoomPreview();

      var photo = document.getElementById('gallery-photo');
      if (photo && cfg.image) {
        photo.src = cfg.image;
        photo.classList.add('visible');
      }

      var gridImg = document.getElementById('grid-card-img');
      if (gridImg && cfg.image) gridImg.src = cfg.image;

      document.querySelectorAll('.swatch').forEach(function (s) {
        s.classList.toggle('active', s.dataset.key === key);
      });
      document.querySelectorAll('.color-card').forEach(function (c) {
        c.classList.toggle('active', c.dataset.key === key);
      });

      var activeSwatch = document.querySelector('.swatch[data-key="' + key + '"]');
      var selectedColor = document.getElementById('selected-color');
      if (activeSwatch && selectedColor) {
        selectedColor.textContent = activeSwatch.dataset.name;
      }
    }

    function applyTemplate(key) {
      currentTemplate = key;
      var templateClass = 'tag-engrave template-' + key;
      tagEngrave.className = templateClass;
      if (tagEngraveBack) tagEngraveBack.className = templateClass;

      document.querySelectorAll('.template-btn').forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.template === key);
      });

      var sample = TEMPLATE_SAMPLES[key];
      if (sample && mode === 'editor') {
        var clubInput = document.getElementById('input-club');
        var nameInput = document.getElementById('input-name');
        var numberInput = document.getElementById('input-number');
        if (clubInput) clubInput.value = sample.club;
        if (nameInput) nameInput.value = sample.name;
        if (numberInput) numberInput.value = sample.number;
      }
      applyEngraveStyle();
      updatePreviewText();
    }

    function updateSidePreview(side, club, name, number, placeholders) {
      var suffix = side === 'back' ? '-back' : '';
      var clubEl = document.getElementById('preview-club' + suffix);
      var nameEl = document.getElementById('preview-name' + suffix);
      var numberEl = document.getElementById('preview-number' + suffix);
      var monogramEl = document.getElementById('preview-monogram' + suffix);
      var emblemEl = document.getElementById('preview-emblem' + suffix);

      if (clubEl) clubEl.textContent = club || placeholders.club || 'クラブ名';
      if (nameEl) nameEl.textContent = name || placeholders.name || 'お名前';
      if (numberEl) numberEl.textContent = number || placeholders.number || '会員番号';
      if (monogramEl) monogramEl.textContent = getMonogram(name);
      if (emblemEl) emblemEl.textContent = getEmblem(club);

      function setOpacity(id, val) {
        var el = document.getElementById(id);
        if (el) el.style.opacity = val ? '' : '0.35';
      }
      setOpacity('preview-club' + suffix, club);
      setOpacity('preview-name' + suffix, name);
      setOpacity('preview-number' + suffix, number);
      setOpacity('preview-monogram' + suffix, name);
      setOpacity('preview-emblem' + suffix, club);
    }

    function updatePreviewText() {
      var placeholders = translations.placeholders || {};
      var backPlaceholders = translations.backPlaceholders || placeholders;

      var clubInput = document.getElementById('input-club');
      var nameInput = document.getElementById('input-name');
      var numberInput = document.getElementById('input-number');

      var club = clubInput ? clubInput.value.trim() : '';
      var name = nameInput ? nameInput.value.trim() : '';
      var number = numberInput ? numberInput.value.trim() : '';

      if (!clubInput) {
        var clubEl = document.getElementById('preview-club');
        if (clubEl) club = clubEl.textContent.trim();
      }
      if (!nameInput) {
        var nameEl = document.getElementById('preview-name');
        if (nameEl) name = nameEl.textContent.trim();
      }
      if (!numberInput) {
        var numberEl = document.getElementById('preview-number');
        if (numberEl) number = numberEl.textContent.trim();
      }

      updateSidePreview('front', club, name, number, placeholders);

      if (tagEngraveBack) {
        var clubBackInput = document.getElementById('input-club-back');
        var nameBackInput = document.getElementById('input-name-back');
        var numberBackInput = document.getElementById('input-number-back');
        var clubBack = clubBackInput ? clubBackInput.value.trim() : '';
        var nameBack = nameBackInput ? nameBackInput.value.trim() : '';
        var numberBack = numberBackInput ? numberBackInput.value.trim() : '';
        updateSidePreview('back', clubBack, nameBack, numberBack, backPlaceholders);
      }
      syncZoomPreview();
    }

    function getEngraveProperties() {
      var fontCfg = FONT_MAP[currentFont] || FONT_MAP.classic;
      var sizeCfg = SIZE_MAP[currentSize] || SIZE_MAP.md;
      var clubInput = document.getElementById('input-club');
      var nameInput = document.getElementById('input-name');
      var numberInput = document.getElementById('input-number');

      var props = {
        'Club Name': clubInput ? clubInput.value.trim() : '',
        'Name': nameInput ? nameInput.value.trim() : '',
        'Member No.': numberInput ? numberInput.value.trim() : '',
        'Engrave Template': currentTemplate,
        'Font Style': fontCfg.label,
        'Font Size': sizeCfg.labelKey,
        'Font Color': engraveColorMode === 'auto' ? 'auto' : (engraveColorMode === 'custom' ? customEngraveColor : engraveColorMode)
      };

      if (isDoubleSided) {
        var clubBackInput = document.getElementById('input-club-back');
        var nameBackInput = document.getElementById('input-name-back');
        var numberBackInput = document.getElementById('input-number-back');
        props['Double-sided'] = 'Yes';
        props['Back Club Name'] = clubBackInput ? clubBackInput.value.trim() : '';
        props['Back Name'] = nameBackInput ? nameBackInput.value.trim() : '';
        props['Back Member No.'] = numberBackInput ? numberBackInput.value.trim() : '';
      }

      return props;
    }

    document.querySelectorAll('.swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = normalizeColorKey(btn.dataset.key);
        applyColor(key);
        syncVariantFromColorKey(key);
      });
    });

    document.querySelectorAll('.color-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var key = normalizeColorKey(card.dataset.key);
        applyColor(key);
        syncVariantFromColorKey(key);
        var swatches = document.getElementById('color-swatches');
        if (swatches) swatches.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    document.querySelectorAll('.template-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { applyTemplate(btn.dataset.template); });
    });

    document.querySelectorAll('.font-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentFont = btn.dataset.font;
        document.querySelectorAll('.font-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.font === currentFont);
        });
        applyEngraveStyle();
      });
    });

    document.querySelectorAll('.size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentSize = btn.dataset.size;
        document.querySelectorAll('.size-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.size === currentSize);
        });
        applyEngraveStyle();
      });
    });

    document.querySelectorAll('.engrave-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        engraveColorMode = btn.dataset.color;
        document.querySelectorAll('.engrave-swatch').forEach(function (b) {
          b.classList.toggle('active', b.dataset.color === engraveColorMode);
        });
        applyEngraveStyle();
      });
    });

    var colorInput = document.getElementById('input-font-color');
    if (colorInput) {
      colorInput.addEventListener('input', function (e) {
        customEngraveColor = e.target.value;
        engraveColorMode = 'custom';
        document.querySelectorAll('.engrave-swatch').forEach(function (btn) { btn.classList.remove('active'); });
        applyEngraveStyle();
      });
    }

    ['input-club', 'input-name', 'input-number', 'input-club-back', 'input-name-back', 'input-number-back'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', updatePreviewText);
    });

    function bindDoubleSidedToggles() {
      var toggles = document.querySelectorAll('.js-double-sided-checkbox');
      if (!toggles.length) return false;
      toggles.forEach(function (cb) {
        cb.addEventListener('change', function () {
          setDoubleSided(cb.checked);
        });
      });
      setDoubleSided(toggles[0].checked);
      return true;
    }

    var zoomModal = document.getElementById('tag-preview-zoom');
    var zoomContent = document.getElementById('tag-preview-zoom-content');
    var zoomOpenBtn = document.getElementById('tag-preview-zoom-open');
    var zoomCloseBtn = document.getElementById('tag-preview-zoom-close');
    var zoomBackdrop = document.getElementById('tag-preview-zoom-backdrop');
    var previewInteractive = document.getElementById('tag-preview-interactive');
    var zoomIsOpen = false;

    function syncZoomPreview() {
      if (!zoomIsOpen || !zoomContent || !previewDual) return;
      zoomContent.innerHTML = '';
      var clone = previewDual.cloneNode(true);
      clone.removeAttribute('id');
      var backFace = clone.querySelector('.tag-preview-face--back');
      if (backFace && previewBackFace) backFace.hidden = previewBackFace.hidden;
      zoomContent.appendChild(clone);
    }

    function openPreviewZoom() {
      if (!zoomModal) return;
      zoomIsOpen = true;
      syncZoomPreview();
      zoomModal.hidden = false;
      zoomModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (zoomOpenBtn) zoomOpenBtn.setAttribute('aria-expanded', 'true');
      if (zoomCloseBtn) zoomCloseBtn.focus();
    }

    function closePreviewZoom() {
      if (!zoomModal) return;
      zoomIsOpen = false;
      zoomModal.classList.remove('is-open');
      zoomModal.hidden = true;
      document.body.style.overflow = '';
      if (zoomOpenBtn) {
        zoomOpenBtn.setAttribute('aria-expanded', 'false');
        zoomOpenBtn.focus();
      }
      if (zoomContent) zoomContent.innerHTML = '';
    }

    if (zoomOpenBtn) {
      zoomOpenBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openPreviewZoom();
      });
    }
    if (previewInteractive) {
      previewInteractive.addEventListener('click', function () { openPreviewZoom(); });
      previewInteractive.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPreviewZoom();
        }
      });
    }
    if (zoomCloseBtn) zoomCloseBtn.addEventListener('click', closePreviewZoom);
    if (zoomBackdrop) zoomBackdrop.addEventListener('click', closePreviewZoom);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && zoomIsOpen) closePreviewZoom();
    });

    bindDoubleSidedToggles();

    window.ForemarkEngrave = {
      applyColor: applyColor,
      getEngraveProperties: getEngraveProperties,
      getCurrentTemplate: function () { return currentTemplate; },
      setDoubleSided: setDoubleSided,
      isDoubleSided: function () { return isDoubleSided; }
    };

    var initialKey = 'black';
    var activeSwatch = document.querySelector('.swatch.active');
    if (activeSwatch && activeSwatch.dataset.key) {
      initialKey = normalizeColorKey(activeSwatch.dataset.key);
    }
    applyColor(initialKey);
    applyTemplate('classic');
    applyEngraveStyle();
    updatePreviewText();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForemarkEngrave);
  } else {
    initForemarkEngrave();
  }
})();
